import './styles.scss';

interface BreadcrumbsProps {
  items: { link?: string; title?: string }[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => (
  <div className="breadcrumbs">
    {items.map(({ link = '/', title }, index) => {
      const separator = index < items.length - 1 ? ' / ' : '';
      const isLastItem = index === items.length - 1;

      return (
        <span key={index}>
          {!isLastItem ? (
            <a href={link} className="">
              {title}
            </a>
          ) : (
            <span className="breadcrumbs__last-item">{title}</span>
          )}

          {separator}
        </span>
      );
    })}
  </div>
);

export default Breadcrumbs;
